import { Box } from '@mui/material'
import { useAtom } from 'jotai'
import LanguageMenu from 'components/LanguageMenu/LanguageMenu'
import { NavCompares, NavFavorites } from 'components/Nav/NavItems'
import { NavMapModal } from 'components/Unit/NavMapModal'
import { isIframeMode } from 'logging/logging'
import React from 'react'
import { overlay_state } from 'state/store.ui'
import { active_project, iso_free } from 'state/store.global'
import { MapModalButton } from 'components/Unit/FullscreenMap'
import { useGet } from 'state/jotai'

const CommoIframenMenus = () => {
  const iFrameEnabled = isIframeMode();
  const [overlayState] = useAtom(overlay_state);
  const buttonRight = overlayState?.detail ? '498px' : '48px';
   const { pin, pid } = useGet(active_project)
    const rmode = useGet(iso_free);
  return (
    iFrameEnabled && !rmode &&
    <Box sx={{ position: 'absolute', zIndex: '10', right: { xs: '16px', md: buttonRight }, bottom: 'calc(100% + 24px)', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <NavCompares sx={{ backgroundColor: '#ffffffbf', borderRadius: '6px', width: '40px', height: '40px' }} />
        <NavFavorites sx={{ backgroundColor: '#ffffffbf', borderRadius: '6px', width: '40px', height: '40px' }} />
        
        {/* <NavMapModal sx={{ width: '40px', height: '40px', padding: '8px', borderRadius: '8px' }} />
         
         <MapModalButton /> */}
        {/* <LanguageMenu /> */}
    </Box>
  )
}

export default CommoIframenMenus